// Zone vertices are stored against a fixed anchor. Interaction uses the
// displayed polygon, including movement and per-vertex attachments.
export function zoneDisplayPoints(points, anchor, center, refs = [], resolve = () => null) {
    const dx = center[0] - anchor[0], dz = center[2] - anchor[2];
    return points.map((p, i) => {
        const bound = refs[i]?.ref && resolve(refs[i].ref);
        return bound ? [bound[0], 0, bound[2]] : [p[0] + dx, p[1] ?? 0, p[2] + dz];
    });
}

export function nearestZoneVertex(points, point, maxDistance = Infinity) {
    if (!point) return null;
    let index = null, distance = maxDistance;
    points.forEach((p, i) => {
        const d = Math.hypot(p[0] - point.x, p[2] - point.z);
        if (d <= distance) { index = i; distance = d; }
    });
    return index;
}

export function zoneInsertionIndex(points, point, closed = true) {
    let index = points.length, distance = Infinity;
    // An open polyline has no edge joining its last point to its first.
    const edges = closed ? points.length : points.length - 1;
    for (let i = 0; i < edges; i++) {
        const a = points[i], b = points[(i + 1) % points.length];
        const dx = b[0] - a[0], dz = b[2] - a[2];
        const length = dx * dx + dz * dz;
        if (length < 1e-6) continue;
        const t = Math.max(0, Math.min(1, ((point.x - a[0]) * dx + (point.z - a[2]) * dz) / length));
        const d = Math.hypot(point.x - a[0] - dx * t, point.z - a[2] - dz * t);
        if (d < distance) { distance = d; index = i + 1; }
    }
    return index;
}
